import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useSessionContext } from '@/features/game/hooks/use-session-context';
import { getGameSpecificDevice } from '@/features/game/platform-helpers';
import { requestIdSelector } from '@/features/game/store/game-data';
import { updateGeolocationToken } from '@/features/geolocation-update-token/store/thunks/update-geolocation-token';
import { UpdateGeolocationToken } from '@/features/geolocation-update-token/types';
import { useAppDispatch } from '@/store/hooks';

export const useUpdateToken = () => {
  const dispatch = useAppDispatch();
  const sessionContext = useSessionContext();

  const requestId = useSelector(requestIdSelector);

  const platform = getGameSpecificDevice() === 'DESKTOP' ? 'DESKTOP' : 'MOBILE';

  const updateGeoToken = useCallback(
    (input: UpdateGeolocationToken) => {
      if (sessionContext && requestId) {
        dispatch(
          updateGeolocationToken({
            authToken: input.authToken,
            loginToken: input.loginToken,
            platform,
            fdState: sessionContext?.fdState,
            geolocationToken: input.geolocationToken,
            requestId,
            ipAddress: input.ipAddress,
            product: input.product,
          }),
        );
      }
    },
    [sessionContext, dispatch, platform, requestId],
  );

  return { updateGeoToken };
};
